import { CompanyTheme } from '../../api/types';
import VehicleCarousel from '../../components/Images';
import type { ThemeComponents } from '../context';
import Calculator from '../default/Calculator';
import CardWithHeader from '../default/CardWithHeader';
import ConfiguratorDepositDisplay from '../default/Configurator/DepositDisplay';
import Tabs from '../default/Tabs';
import Title from '../default/Title';
import Tooltip from '../default/Tooltip';
import makeThemeComponents from '../makeThemeComponents';
import Anchor from './Anchor';
import ArrowDownIcon from './ArrowDownIcon';
import BackButton from './BackButton';
import Button from './Button';
import Carousel from './Carousel';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import CloseButton from './CloseButton';
import ComparisonButton from './ComparisonButton';
import ConfiguratorChatIcon from './Configurator/ChatIcon';
import ConfiguratorDropdown from './Configurator/Dropdown';
import ConfiguratorLayout from './Configurator/Layout';
import ConfiguratorMessageButton from './Configurator/MessageButton';
import ConfiguratorSubHeader from './Configurator/SubHeader';
import ConsentModal from './ConsentModal';
import LegalText from './ConsentsAndDeclarations/LegalText';
import Dropdown from './Dropdown';
import ErrorMessageBox from './ErrorMessageBox';
import CheckboxInputField from './Fields/CheckboxField';
import CountryField from './Fields/CountryField';
import DatePickerField from './Fields/DatePickerField';
import DisplayField from './Fields/DisplayField';
import DisplayFieldWithUTCOffset from './Fields/DisplayFieldWithUTCOffset';
import FixedRangePickerField from './Fields/FixedRangePickerField';
import GenderField from './Fields/GenderField';
import IdentityNumberField from './Fields/IdentityNumberField';
import InputField from './Fields/InputField';
import InputNumberField from './Fields/InputNumberField';
import MaritalStatusField from './Fields/MaritalStatusField';
import MultipleDraggerField from './Fields/MultipleDraggerField';
import NationalityField from './Fields/NationalityField';
import PasswordField from './Fields/PasswordField';
import PhoneAndPrefixField from './Fields/PhoneAndPrefixField';
import RaceField from './Fields/RaceField';
import RangePickerField from './Fields/RangePickerField';
import RegionField from './Fields/RegionField';
import ResidentialStatusField from './Fields/ResidentialStatusField';
import SelectField from './Fields/SelectField';
import SwitchField from './Fields/SwitchField';
import TimeRangePickerField from './Fields/TimeRangePickerField';
import TranslatedInputField from './Fields/TranslatedInputField';
import FinderLayout from './Finder/Layout';
import InfoMessageBox from './InfoMessageBox';
import Input from './Input';
import JourneySteps from './JourneySteps';
import ListItem from './ListItem';
import LoadingSpinner from './LoadingSpinner';
import MobilityWebpageLayout from './Mobility/WebPageLayout';
import Modal from './Modal';
import notification from './notification';
import PageWithHeader from './PageWithHeader';
import PaginatedTableWithContext from './PaginatedTableWithContext';
import Popconfirm from './Popconfirm';
import PorscheGlobalStyles from './PorscheGlobalStyles';
import Radio from './Radio';
import RangePicker from './RangePicker';
import Search from './Search';
import Select from './Select';
import StandardLayout from './Standard/Layout';
import Steps from './Steps';
import TimePicker from './TimePicker';
import WarningMessageBox from './WarningMessageBox';

const PorscheTheme: ThemeComponents = {
    theme: CompanyTheme.Porsche,
    gutter: {
        testDriveModal: [14, 14],
    },
    Input,
    ConfiguratorDropdown,
    ConfiguratorSubHeader,
    ConfiguratorMessageButton,
    ConfiguratorChatIcon,
    ConfiguratorDepositDisplay,
    PageWithHeader,
    Dropdown,
    Select,
    StandardLayout,
    ConfiguratorLayout,
    Button,
    Title,
    MobilityWebpageLayout,
    BackButton,
    CloseButton,
    ComparisonButton,
    FinderLayout,
    Checkbox,
    CheckboxGroup,
    RangePicker,
    TimePicker,
    FormFields: {
        RangePickerField,
        FixedRangePickerField,
        SelectField,
        InputField,
        InputNumberField,
        DatePickerField,
        IdentityNumberField,
        NationalityField,
        PhoneAndPrefixField,
        RegionField,
        CountryField,
        MultipleDraggerField,
        TimePickerField: TimeRangePickerField,
        RaceField,
        GenderField,
        ResidentialStatusField,
        MaritalStatusField,
        TranslatedInputField,
        CheckboxField: CheckboxInputField,
        SwitchField,
        DisplayField,
        PasswordField,
        DisplayFieldWithUTCOffset,
    },
    LoadingSpinner,
    Modal,
    ConsentModal,
    notification,
    Radio,
    RadioGroup: Radio.Group,
    CardWithHeader,
    Steps,
    Search,
    ErrorMessageBox,
    InfoMessageBox,
    WarningMessageBox,
    JourneySteps,
    PaginatedTableWithContext,
    Popconfirm,
    Carousel,
    Tooltip,
    Calculator,
    ListItem,
    Tabs,
    Anchor,
    LegalText,
    ArrowDownIcon,
    VehicleCarousel,
};

export default makeThemeComponents('PorscheThemeProvider', PorscheTheme, PorscheGlobalStyles);
